module.exports = __webpack_public_path__ + "img/logo-dark.2ed8156b.png";